import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref, watch } from "vue";
import { RouteRecordRaw } from "vue-router";
import { usePermissions } from "@/use/usePermissions";

import { useStore } from "@/use/useStore";
import { routes } from "@/router/routes";

import UiCell from "@/plugins/ui/components/cell/UiCell.vue";
import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";

import AppLogo from "./AppLogo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSidebar',
  setup(__props) {

const { currentUser } = useStore();
const { isAllow } = usePermissions();

const filteredRoutes = ref<RouteRecordRaw[]>([]);

function calculateRoutes() {
  filteredRoutes.value = routes.filter((route: any) => {
    const allowed = route.meta?.allowFor ? isAllow(route.meta.allowFor) : true;
    const notHidden = !route.meta?.hidden;
    return allowed && notHidden;
  });
}

watch(() => currentUser.value?.id, calculateRoutes, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(AppLogo, { class: "mb-8 px-2" }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRoutes.value, (route) => {
      return (_openBlock(), _createBlock(UiCell, {
        key: route.path,
        to: route.path,
        title: route.meta?.title,
        expandable: ""
      }, {
        left: _withCtx(() => [
          (route.meta?.icon)
            ? (_openBlock(), _createBlock(UiIcon, {
                key: 0,
                icon: route.meta.icon
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["to", "title"]))
    }), 128))
  ]))
}
}

})